import { Link } from "react-router-dom";
import { useWaitlist } from "../context/WaitlistContext";
import ElevateBadge from "./ElevateBadge";

export default function Footer() {
  const { openWaitlist } = useWaitlist();
  return (
    <footer
      className="border-t border-white/10 bg-ink"
      data-testid="footer"
    >
      <div className="container-x py-16">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Link to="/" className="flex items-center gap-2.5">
              <img
                src="/brand/smritium-mark-white.png"
                alt=""
                className="h-9 w-9 object-contain"
              />
              <span className="font-display text-2xl lowercase text-paper">
                smritium
              </span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-mute">
              The sovereign memory layer for AI. A local-first memory substrate
              for people and enterprises — your context, your machine, your
              terms.
            </p>
            <div className="mt-6">
              <ElevateBadge />
            </div>
          </div>

          <div>
            <p className="overline">Explore</p>
            <ul className="mt-4 space-y-3 text-sm text-mute">
              <li>
                <a
                  href="/#substrate"
                  className="transition-colors hover:text-paper"
                >
                  The Substrate
                </a>
              </li>
              <li>
                <a
                  href="/#difference"
                  className="transition-colors hover:text-paper"
                >
                  Why we're different
                </a>
              </li>
              <li>
                <a
                  href="/#vision"
                  className="transition-colors hover:text-paper"
                >
                  Sovereignty
                </a>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-paper">
                  About · Research
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="overline">Get early access</p>
            <p className="mt-4 text-sm text-mute">
              Join the waitlist and help shape a sovereign memory layer built in
              India.
            </p>
            <button
              onClick={() => openWaitlist()}
              className="btn-primary mt-5"
              data-testid="footer-waitlist-button"
            >
              Join the Waitlist
            </button>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-mute md:flex-row md:items-center">
          <p>
            © {new Date().getFullYear()}{" "}
            <a
              href="https://datafrontier.co"
              target="_blank"
              rel="noreferrer"
              className="underline decoration-ember/40 underline-offset-2 transition-colors hover:text-paper"
            >
              DataFrontier Innovations
            </a>
            . Smritium is a research-led product.
          </p>
          <p className="font-mono">
            smṛti · स्मृति — “that which is remembered.” Built in Karnataka,
            India.
          </p>
        </div>
      </div>
    </footer>
  );
}
